import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coach-share',
  templateUrl: './coach-share.component.html',
  styleUrls: ['./coach-share.component.scss']
})
export class CoachShareComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
